import React from "react";
import PropTypes from 'prop-types';
// noinspection ES6CheckImport
import {
	Document,
	Page,
	Text,
	View,
	StyleSheet,
	PDFDownloadLink,
	PDFViewer,
} from "@react-pdf/renderer";
import Framework from '@beardeddevops/react.framework';

const styles = StyleSheet.create({
	page: {
		flexDirection: "row",
		backgroundColor: "#FFFFFF",
	},
	section: {
		margin: 10,
		padding: 2,
		flexGrow: 1,
	},
	header: {
		fontSize: 12,
	},
	row: {
		fontSize: 10,
	},
});

class CSVToPDF extends React.Component {
	render() {
		const {headers, rows} = this.props;

		return (
			<Document>
				<Page
					size="A4"
					orientation="landscape"
					style={styles.page}
				>
					{headers.map((header, i) => {
						return (
							<View key={i} style={styles.section}>
								<Text style={styles.header}>{header.label}</Text>
								{rows.map((row, i) => {
									return (
										<Text key={i} style={styles.row}>
											{row[header.key]}
										</Text>
									);
								})}
							</View>
						);
					})}
				</Page>
			</Document>
		);
	}
}

// This component mounts, PDFDownloadLink generates a blob URL that is passed to its child,
// and PDFDownload clicks the child to trigger the download prompt. This needs to be done
// because the URL passed to the child doesn't work with window.open().
export class PDFDownload extends React.Component {
	static propTypes = {
		rows: PropTypes.array,
		headers: PropTypes.array,
		fileName: PropTypes.string,
		onClose: PropTypes.func,
	};

	getRef = (ref) => {
		if (!ref) return;

		ref.click();

		if (typeof this.props.onClose === 'function') this.props.onClose();
	}

	render() {
		const {rows, headers, fileName} = this.props;

		return (
			<PDFDownloadLink
				document={
					<CSVToPDF rows={rows} headers={headers}/>
				}
				fileName={fileName}
			>
				{({loading}) => {
					if (!loading) {
						return <div ref={this.getRef}/>
					}

					return null;
				}}
			</PDFDownloadLink>
		);
	}
}

export class PDFPreviewModal extends React.Component {
	componentDidMount() {
		this.rootStateID = this.props.rootState.subscribe({
			height: null,
		});
	}

	componentWillUnmount() {
		this.props.rootState.unsubscribe(this.rootStateID);
	}

	render() {
		const {rows, headers, rootState} = this.props;
		const {height} = rootState;

		return (
			<PDFViewer
				width="100%"
				height={`${height * 0.5}px`}>
				<CSVToPDF rows={rows} headers={headers}/>
			</PDFViewer>
		);
	}
}

PDFPreviewModal = Framework.Components.withRootState(PDFPreviewModal);
